import __request__ from "routing/request";
export function initiateCertRenewalForNode(nodeID, requestOptions) {
  return __request__("POST", `/certrenewal/${nodeID}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
